import { COLORS } from 'src/styles/theme'
import styled from 'styled-components'

export const PageStyle = styled.div`
  background: radial-gradient(#4c8d99, #1d3242);
  color: #fff;

  .pageContainer {
    min-height: 100vh;
    display: grid;
    grid-template-rows: auto 60px 1fr 10px;
    max-width: 900px;
    margin: 0 auto;
    padding-top: 32px;
    padding-bottom: 32px;
  }

  .badgeSelection {
    display: grid;
    grid-template-columns: repeat(auto-fill, 150px);
    grid-gap: 0 5px;

    a,
    .badge {
      width: 100%;
      &:hover {
        color: ${COLORS.primary};
      }
    }
  }
  .text-truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: left;
  }

  header {
    h5 {
      margin: 0;
      font-size: 15px;
    }
    select.form-input {
      text-align-last: center;
      border: none;
      border-radius: 18px;
      padding: 4px 16px;
      font-size: 14px;
    }
  }

  .questionsContainer {
    border-radius: 8px;
    background-color: rgba(255, 255, 255, 0.9);
    overflow-y: scroll;
  }
`